/******************************************************************************************
 *	Bulk Change Customers Reseller Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.licenseAdminBulkChangeResellerController', []).controller(
    'LicenseAdminBulkChangeResellerController',
    /* @ngInject */
    function(
      _,
      $log,
      $state,
      $stateParams,
      $scope,
      $translate,
      ALERT_MODAL_TYPES,
      ArrayToCsv,
      CSV_COLUMN_SEPARATOR,
      CSV_ROW_SEPARATOR,
      CsvToArray,
      csvUtils,
      CurtainNotifications,
      Customer,
      downloadUtils,
      LicenseAdminSearch,
      LicenseAdminSearchCriteria,
      Reseller,
      Settings,
      SspList,
      User
    ) {
      var vm = this;

      vm.customerList = [];
      vm.migrationCompleted = false;
      vm.migrationCancelled = false;
      vm.customerListToMigrate = [];
      vm.migratedCustomersList = [];
      vm.customerMigrationErrorList = [];
      vm.customerInMigration = null;
      vm.migrationStartTime = 0;

      /*=== Import customer list from CSV file ===*/
      vm.fileContent = null;
      vm.importCsvContent = function() {
        // Reset customerList, so we can repopulate it with CSV content.
        vm.customerList = [];
        vm.dataError = false;
        vm.dataErrorMessage = '';
        // Parse the CSV content
        // eslint-disable-next-line lodash/prefer-lodash-method
        var customerEntries = CsvToArray.convert(vm.fileContent).filter((entry) => !_.isEmpty(entry.filter(Boolean)));
        if (!customerEntries || customerEntries.length === 0) {
          vm.dataError = true;
          vm.dataErrorMessage = 'licenseAdminBulkChangeReseller.emptyFileError';
        }
        _.forEach(customerEntries, function(customerData) {
          // We expect the columns to be in the following order:
          // Customer VIP number, Customer Org Id, Reseller Org Id
          if (customerData.length < 3) {
            // We're missing some data.
            vm.dataError = true;
            vm.dataErrorMessage = 'licenseAdminBulkChangeReseller.missingColumnsError';
          } else {
            var customerObj = {};
            customerObj.vip = customerData[0];
            customerObj.orgId = customerData[1];
            customerObj.resellerOrgId = customerData[2];
            // Do some basic validation on the values. If they don't match up, push it to the list
            // anyway, so the customer can view along with the warning.
            $log.info(customerObj.orgId.indexOf('@AdobeOrg'));
            if (customerObj.vip.length !== 20) {
              vm.dataError = true;
              vm.dataErrorMessage = 'licenseAdminBulkChangeReseller.vipNumberValidationError';
            } else if (
              customerObj.orgId.length !== 33 ||
              customerObj.orgId.indexOf('@AdobeOrg') !== 24
            ) {
              vm.dataError = true;
              vm.dataErrorMessage = 'licenseAdminBulkChangeReseller.orgIdValidationError';
            } else if (
              customerObj.resellerOrgId.length !== 33 ||
              customerObj.resellerOrgId.indexOf('@AdobeOrg') !== 24
            ) {
              vm.dataError = true;
              vm.dataErrorMessage = 'licenseAdminBulkChangeReseller.resellerOrgIdValidationError';
            }
            // Add data to our customer list
            vm.customerList.push(customerObj);
          }
        });
      };

      vm.chooseNewCsv = function() {
        // Clear the customer list, so the File Chooser UI is shown
        vm.customerList = [];
        vm.dataError = false;
        vm.dataErrorMessage = '';
      };

      /*=== Select New Reseller ===*/
      // This section of code uses the license-admin-search-form, which expects
      // variables and methods to be on $scope rather than vm.

      //Make search criteria available in view
      $scope.LicenseAdminSearchCriteria = LicenseAdminSearchCriteria;
      $scope.searchOptions = LicenseAdminSearchCriteria.getResellerOnlyOptions();
      $scope.resellersOnly = true;

      $scope.showSearchResults = false; //Toggles search results table
      $scope.searchInProgress = false; //True when search is in progress, false otherwise

      //Controls which results table is displayed.
      //There's are 2 tables: one for customers and one for resellers.
      //When set, a value from LICENSE_ADMIN_SEARCH_TYPES is assigned to it.
      $scope.searchType = null;

      //Search
      //Control vars for UI validation errors
      $scope.searchSubmitAttempted = false; //Was submit button clicked?

      var resetSearchSubmit = function() {
        $scope.searchSubmitted = false;
        $scope.searchSubmitAttempted = false;
      };

      $scope.submitSearch = function() {
        if (!$scope.searchSubmitted) {
          $scope.searchSubmitAttempted = true;

          if ($scope.searchForm.$valid) {
            $scope.searchSubmitted = true;
            $scope.searchInProgress = true;

            //Hide current search results table upon submit
            $scope.showSearchResults = false;

            //Structure data as needed by API
            var payload = {
              qField: $scope.searchCriteria.value,
              q: $scope.searchTerm
            };

            $log.info('%cLA search payload ::', 'font-weight:bold;color:#009966;', payload);

            //POST to service
            LicenseAdminSearch.get($scope.searchCriteria.searchType, payload)
              .then(function(responseData) {
                //Remove reseller orgs which have not accepted the invitation
                var filteredData;
                if (_.isArray(responseData)) {
                  filteredData = _.filter(responseData, ['active', true]);
                }

                initSearchResults(filteredData);
                $scope.searchResultCount = responseData.length;
                $scope.noSearchData = false;
                $scope.showSearchResults = true;
              })
              .catch(function(response) {
                $log.error('Failed to perform license admin search', response.data);

                if (response.status !== 0) {
                  //status is 0 when call is aborted
                  if (
                    response.status === 400 &&
                    response.data.errorCode === 'INVALID_SEARCH_CRITERIA'
                  ) {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                  } else if (response.status === 404) {
                    $scope.searchErrorMessage = 'global.dataList.emptyMessages.noResultsFound';
                    $scope.noSearchData = true;
                    $scope.showSearchResults = true;
                  } else {
                    CurtainNotifications.show(
                      CurtainNotifications.ERROR,
                      'generic.notifications.error'
                    );
                  }
                }
              })
              .finally(function() {
                //Tell the view what kind of search type is being performed
                //This is set after data is fetched so that the view doesn't change the table before new data is in.
                $scope.searchType = $scope.searchCriteria.searchType;

                //Allow new searches
                resetSearchSubmit();

                $scope.searchInProgress = false;
              });
          }
        }
      };

      //Team Members Data List init and refresh
      var searchResultsDataList;
      var refreshDataList = function(options) {
        $scope.searchResults = searchResultsDataList.get(options);
        if (!$scope.searchResults.data.length) {
          $scope.noSearchResults = true;
          $scope.searchErrorMessage = 'global.dataList.emptyMessages.noResultsFound';
        } else {
          $scope.noSearchResults = false;
        }
      };

      var initSearchResults = function(data) {
        searchResultsDataList = new SspList(data, {
          itemsPerPage: Settings.itemsPerPage.default
        });

        refreshDataList({page: 1});
      };

      //Pagination
      $scope.prevPage = function() {
        var page = $scope.searchResults.pagination.currentPage - 1;
        refreshDataList({page: page});
      };
      $scope.nextPage = function() {
        var page = $scope.searchResults.pagination.currentPage + 1;
        refreshDataList({page: page});
      };

      //Sorting
      $scope.sort = function(column, serverColumns, isNumeric) {
        refreshDataList({sortBy: column, sortNumeric: isNumeric});
      };

      //Search
      $scope.search = function(query) {
        refreshDataList({query: query});
      };
      $scope.clearSearch = function() {
        searchResultsDataList.clearSearch();
        refreshDataList();
      };

      /*=== Select Reseller ===*/

      //True when a new reseller is selected, false otherwise.
      //vm.newReseller!==null could be used to determine this rendering this var useless
      //if it wasn't for animations.
      //If we tied view state to truthy-ness of vm.newReseller, when this was null-ified
      //the transition would happen, but it would also trigger the watchers to update DOM
      //resulting in an ungly flicker.
      //Using newResellerSelected to control view state and not null-ifying newReseller allows
      //for a smooth animation
      vm.newResellerSelected = false;

      $scope.resellerAction = function(event, reseller) {
        event.preventDefault();

        if (reseller.active) {
          vm.newResellerSelected = true;
          vm.newReseller = reseller;
        }
      };

      /*==== Migrate customers ====*/
      vm.cancelMigration = function() {
        vm.migrationCancelled = true;
      };

      var migrationComplete = function() {
        vm.migrationCompleted = true;
        if (vm.customerMigrationErrorList.length > 0) {
          vm.migrationErrors = true;
        }
        vm.migrationSecondsElapsed = Math.round((Date.now() - vm.migrationStartTime) / 1000);
        $log.info(
          'Migration ' +
            (vm.migrationCancelled ? 'cancelled' : 'completed') +
            ' after ' +
            vm.migrationSecondsElapsed +
            ' seconds.'
        );
      };

      var migrateNextCustomer = function() {
        if (vm.customerListToMigrate.length === 0 || vm.migrationCancelled) {
          vm.customerInMigration = null;
          migrationComplete();
        } else {
          vm.customerInMigration = vm.customerListToMigrate.pop();
          migrateCustomer(vm.customerInMigration.orgId, vm.customerInMigration.resellerOrgId);
        }
      };

      var migrateCustomer = function(customerOrgId, customerResellerOrgId) {
        // Set up the User to impersonate the customerResellerOrgId for doing the modify customer calls
        if (User.getResellerID !== customerResellerOrgId) {
          User.setImpersonatedReseller({id: customerResellerOrgId});
        }

        // Migrate the customer to the new reseller
        Customer.migrateToNewReseller(customerOrgId, vm.newReseller.id)
          .then(function(responseData) {
            vm.migratedCustomersList.push(responseData);
            migrateNextCustomer();
          })
          .catch(function(response) {
            $log.warn(response.data, response.status);
            // add the customer to the error list with the error message
            vm.customerInMigration.errorMessage = response.data
              ? response.data.errorMessage || ''
              : 'CANCELLED';
            vm.customerMigrationErrorList.push(vm.customerInMigration);
            migrateNextCustomer();
          });
      };

      /*=== Select Reseller ===*/

      //Cancel customer migration
      vm.cancel = function() {
        vm.newResellerSelected = false;
        vm.newReseller = null;
      };

      //Ask JIL to migrate customer to selectedReseller
      vm.submit = function() {
        if (vm.newReseller && vm.customerList && vm.customerList.length > 0) {
          vm.submitted = true;
          vm.migrationType = 'RESELLER';
          vm.migrationErrors = false;
          // Create a copy of the customer list to iterate over
          vm.customerListToMigrate = vm.customerList.slice();

          // Start migrating the list
          vm.migrationCancelled = false;
          vm.migrationCompleted = false;
          vm.migrationStartTime = Date.now();
          migrateNextCustomer();
        }
      };

      vm.exportFailedMigrationCustomersToCsv = function() {
        var csvContent =
          $translate.instant('licenseAdminBulkChangeReseller.migratingCustomersToReseller', {
            resellerName: vm.newReseller.name,
            resellerContractId: vm.newReseller.externalSalesContractId,
            customerCount: vm.customerList.length
          }) + CSV_ROW_SEPARATOR;
        csvContent +=
          $translate.instant('licenseAdminBulkChangeReseller.errorCustomers', {
            count: vm.customerMigrationErrorList.length
          }) + CSV_ROW_SEPARATOR;
        csvContent += CSV_ROW_SEPARATOR; // Empty line to separate informational rows from customer data rows
        // Row headers
        csvContent +=
          $translate.instant('licenseAdminBulkChangeReseller.vip') + CSV_COLUMN_SEPARATOR;
        csvContent +=
          $translate.instant('licenseAdminBulkChangeReseller.orgId') + CSV_COLUMN_SEPARATOR;
        csvContent +=
          $translate.instant('licenseAdminBulkChangeReseller.resellerOrgId') + CSV_COLUMN_SEPARATOR;
        csvContent +=
          $translate.instant('licenseAdminBulkChangeReseller.errorMessage') + CSV_ROW_SEPARATOR;
        // Customer rows
        csvContent += ArrayToCsv.convert(vm.customerMigrationErrorList);
        //Trigger file download
        downloadUtils.downloadExportData(csvContent, 'failed-migration-customers.csv');
      };

      // Updating customer list's managed by to current reseller's primary admin
      var updateManagedByComplete = function() {
        vm.migrationCompleted = true;
        if (vm.customerMigrationErrorList.length > 0) {
          vm.migrationErrors = true;
        }
        vm.migrationSecondsElapsed = Math.round((Date.now() - vm.migrationStartTime) / 1000);
        $log.info(
          'Update of managed by ' +
            (vm.migrationCancelled ? 'cancelled' : 'completed') +
            ' after ' +
            vm.migrationSecondsElapsed +
            ' seconds.'
        );
      };

      var updateManagedByForCustomer = function(customerOrgId, customerResellerOrgId) {
        // Set up the User to impersonate the customerResellerOrgId for doing the modify customer calls
        if (User.getResellerID !== customerResellerOrgId) {
          User.setImpersonatedReseller({id: customerResellerOrgId});
        }

        Reseller.get(customerResellerOrgId).then(function(responseData) {
          const newSalesRepId = _.get(responseData, 'primaryAdmin.userId');

          if (newSalesRepId) {
            // Migrate the customer to the new reseller
            Customer.updateSalesRep(customerOrgId, newSalesRepId)
              .then(function(responseData) {
                vm.migratedCustomersList.push(responseData);
                updateManagedByForNextCustomer();
              })
              .catch(function(response) {
                $log.warn(response.data, response.status);
                // add the customer to the error list with the error message
                vm.customerInMigration.errorMessage = response.data
                  ? response.data.errorMessage || ''
                  : 'CANCELLED';
                vm.customerMigrationErrorList.push(vm.customerInMigration);
                updateManagedByForNextCustomer();
              });
          } else {
            vm.customerInMigration.errorMessage = 'no primary admin found';
            vm.customerMigrationErrorList.push(vm.customerInMigration);
            updateManagedByForNextCustomer();
          }
        });
      };

      var updateManagedByForNextCustomer = function() {
        if (vm.customerListToUpdateManagedBy.length === 0 || vm.migrationCancelled) {
          vm.customerInMigration = null;
          updateManagedByComplete();
        } else {
          vm.customerInMigration = vm.customerListToUpdateManagedBy.pop();
          updateManagedByForCustomer(
            vm.customerInMigration.orgId,
            vm.customerInMigration.resellerOrgId
          );
        }
      };

      vm.updateMangedByToPrimary = function() {
        if (vm.customerList && vm.customerList.length > 0) {
          vm.submitted = true;
          vm.migrationType = 'MANAGED_BY';
          vm.migrationErrors = false;
          // Create a copy of the customer list to iterate over
          vm.customerListToUpdateManagedBy = vm.customerList.slice();

          // Start migrating the list
          vm.migrationCancelled = false;
          vm.migrationCompleted = false;
          vm.migrationStartTime = Date.now();
          updateManagedByForNextCustomer();
        }
      };

      //Navigation
      vm.goBack = function() {
        $state.go('licenseAdmin.search');
      };
    }
  );
})();
